"use client";
import { useQuery } from "@tanstack/react-query";

import { recommendations } from "@/app/products/[...category]/serverUtils/depict";

import { getDepictMarketFromPricelistId } from "@/app/products/[...category]/serverUtils/helpers";
import { ProductCard } from "@/components/atoms";
import { ProductCard as PC } from "@/lib/centra/formatters/formatProductCards/formatProductCard";
import { DepictOptions } from "@/lib/depict/types";
import { getUserData } from "@/lib/global/actions";
import { useCart } from "@/lib/hooks/useSelection";

import {
  DepictDisplay,
  formatDepictDisplayToPC,
} from "@/app/products/[...category]/serverUtils/getInitialPlpData";
import { Carousel } from "@/components/atoms/Carousel/Carousel";
import styles from "./cart.module.css";

export const CartUpsell = () => {
  const { cart } = useCart();

  const productIds =
    cart?.items?.map((item) => item.itemId?.split("-")[1]).filter(Boolean) ??
    [];

  const { data: cartUpsellProducts, isLoading } = useQuery({
    queryKey: ["cart-upsell", productIds],
    queryFn: async () => {
      const userData = await getUserData();

      const options: DepictOptions = {
        locale: "en",
        session_id: userData?.token,
        product_ids: productIds.filter(Boolean).map(String),
        type: "after_basket",
        limit: 8,
        market: getDepictMarketFromPricelistId(userData?.pricelist) || "us",
      };

      const result = await recommendations("camillapihl", options);

      if (!result.ok) {
        console.error("Depict recommendation error", result.err);
        throw new Error("Failed to fetch related products");
      }

      return (result.val.displays as unknown as DepictDisplay[])
        .map((display) => formatDepictDisplayToPC(display))
        .filter(Boolean) as PC[];
    },
  });

  if (!cartUpsellProducts) return null;
  const filteredUpsellProducts = cartUpsellProducts?.filter(
    (product) =>
      product.id !== "1544" && product.core?.slug !== "small-jewellry-box"
  );

  return (
    <div data-blok style={{ marginBottom: "1rem" }}>
      <Carousel
        showControls={true}
        title={"You might also like"}
        titleStyle={styles.cartUpsellTitle}
      >
        {filteredUpsellProducts?.map((product) => (
          <div key={product.id}>
            <ProductCard
              className="product-card"
              product={product}
              actionClassName={styles.cartUpsellAction}
            />
          </div>
        ))}
      </Carousel>
    </div>
  );
};
